import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { ContainerTitle, FullSizedButton} from "../styles";
import { SessionTitle} from "./styles";
import CustomizedMenus from "components/CustomizedMenu";
import api from "services/structure/api";
import { bindActionCreators } from "redux";
import {
  startLoadingAnimate,
  stopLoadingAnimate,
} from "services/ducks/loading";
import { connect } from "react-redux";
import { withSnackbar } from "notistack";
import * as FontAwesome from "@fortawesome/react-fontawesome";
import { faReceipt } from "@fortawesome/free-solid-svg-icons";

class Transparencia extends Component {  
  state = {
    secoes: [],
    documentos: []  
  };

  componentDidUpdate(prevProps){
    if (this.state.id !== prevProps.authData.usuario.pessoa.id) {
      this.setState({ id : prevProps.authData.usuario.pessoa.id })
      this.buscarTodosOsDados();
    }
  }

  componentDidMount() {
    this.buscarTodosOsDados();
  }

  buscarTodosOsDados = () => {
    this.props.startLoadingAnimate();
    
    const promises = [];
    const dadosTransparencia = this.buscarDadosTransparencia()

    promises.push(dadosTransparencia);

    Promise.all(promises)
    .then(values => {
      const newState = Object.assign(...values);
      this.setState(newState);
    })
    .catch(e => {
      console.log(e);
      const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
      this.props.enqueueSnackbar(mensagem, { variant: "error" });
    })
    .finally(() => this.props.stopLoadingAnimate());
  }

  buscarDadosTransparencia = () => {
    return api.get("documentos/transparencia")
      .then(response => {
        const dados = response.data;
        const listaDocumentos = this.criarListaDocumentos(response.data)
        return { secoes: dados, documentos: listaDocumentos };
      })
      .catch((err) => console.error(err));
  }

  criarListaDocumentos = (secoes) => {
    const documentos = []

    secoes.map(secaoPrincipal => 
      secaoPrincipal.subSecoes.map(subSecao => 
        documentos.push(...subSecao.documentos)
    ))

    return documentos;
  }

  downloadDocumento = (titulo) => {
    const documento = this.state.documentos.filter(doc => doc.titulo === titulo)
    const link = document.createElement("a");
    link.href = documento[0].url;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  }

  downloadCertificadoParticipante = (parte, nomeArquivo) => {
    this.props.startLoadingAnimate();
    return api.get(`documentos/certificado-participante-parte-${parte}`, { responseType: "blob" })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", nomeArquivo);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((err) => {
        console.error(err);
        const mensagem = "Não foi possível gerar o certificado. Tente novamente!";
        this.props.enqueueSnackbar(mensagem, { variant: "error" });
      })
      .finally(() => this.props.stopLoadingAnimate());
  }

  renderDropdown = (subSecao) => (
    subSecao.documentos.length > 0 &&
    <Col sm={12} md={4} key={subSecao.titulo}>
                  <CustomizedMenus 
                    title={subSecao.titulo}
                    lista={subSecao.documentos.map(doc => doc.titulo)}
                    onClick={this.downloadDocumento}   
                    />
    </Col>
  )

  renderBotao = (titulo, doc) => (
    <Col sm={12} md={4} key={titulo}>
        <FullSizedButton
        type="submit"
        className="extrato-participante"
        variant="contained"
        onClick={() => this.downloadDocumento(doc.titulo)}
        >
          <FontAwesome.FontAwesomeIcon
            icon={faReceipt}
            className="extrato-participante-icon"
          />
          <span className="botao-meu-plano">
            {doc.titulo}
          </span>
        </FullSizedButton>
    </Col>
  )

  renderBotaoCertificado = (label, parte, nomeArquivo) => (
    <Col sm={12} md={4} key={`certificado-parte-${parte}`}>
      <FullSizedButton
        type="button"
        className="extrato-participante"
        variant="contained"
        onClick={() => this.downloadCertificadoParticipante(parte, nomeArquivo)}
      >
        <FontAwesome.FontAwesomeIcon
          icon={faReceipt}
          className="extrato-participante-icon"
        />
        <span className="botao-meu-plano">
          {label}
        </span>
      </FullSizedButton>
    </Col>
  )

  renderBotoesCertificadoParticipante = () => (
    <Row>
      {this.renderBotaoCertificado(
        "CERTIFICADO DO PARTICIPANTE - PARTE I",
        1,
        "Certificado-Participante-Parte-I.pdf"
      )}
      {this.renderBotaoCertificado(
        "CERTIFICADO DO PARTICIPANTE - PARTE II",
        2,
        "Certificado-Participante-Parte-II.pdf"
      )}
    </Row>
  )

  renderSecaoPrincipal = (secao) => (
    <>
      <SessionTitle>{secao.nomeSecao}</SessionTitle>
      <Row key={secao.nomeSecao}>
        {
          secao.subSecoes.map(subSecao =>
              !subSecao.botao ? this.renderDropdown(subSecao)               
            :
              subSecao.documentos.map(doc => 
                this.renderBotao(subSecao.titulo, doc)
              )
          )
        }        
      </Row>
      {secao.nomeSecao && secao.nomeSecao.toUpperCase() === "DOCUMENTOS" && this.renderBotoesCertificadoParticipante()}
    </>
  )

  render() {
    const possuiSecaoDocumentos = this.state.secoes.some(
      secao => secao.nomeSecao && secao.nomeSecao.toUpperCase() === "DOCUMENTOS"
    );

    return (
      <div className="transparencia">
        <ContainerTitle>TRANSPARÊNCIA</ContainerTitle>
        {
          this.state.secoes.map(secao => 
              this.renderSecaoPrincipal(secao)
          )
        }
        {!possuiSecaoDocumentos && (
          <>
            <SessionTitle>Documentos</SessionTitle>
            {this.renderBotoesCertificadoParticipante()}
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = store => ({
  authData: store.authState,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ startLoadingAnimate, stopLoadingAnimate }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(Transparencia));
